// i18n area 'apps' — locale hr-HR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.hr-HR.meta.json.
import type { enUS } from './apps'

export const hrHR: typeof enUS = {
  apps: {
    title: 'Aplikacije',
    create: 'Stvori aplikaciju',
    createTitle: 'Stvorite aplikaciju',
    editTitle: 'Uredite aplikaciju',
    name: 'Naziv',
    nameHint: 'DNS-1123, jedinstveno unutar scopea — nepromjenjivo nakon stvaranja.',
    node: 'Čvor',
    nodeHint: 'Članski čvor koji je poslužuje — eksplicitni placement (scheduler dolazi poslije).',
    image: 'Slika',
    editImageHint: 'Nova referenca ponovno se razrješava kroz matične podatke — gesta pina/rollbacka.',
    imagePolicy: 'Policy',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Digest se pomiče samo na naredbu.',
    policyTrackingHint: 'Automatski prijelaz kad refresh pomakne branch.',
    archMovePolicy: 'Cross-arch premještanje',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Što se događa ako se app premjesti na node druge arhitekture: refuse odbija premještanje, reresolve iznova razrješava lockfile s brancha na novoj arch — sadržaj se mijenja, i odgovor imenuje promjenu digesta.',
    network: 'Mreža',
    networkHint: 'Untagged L3 priključak: logička mreža fabrica (preporučena — pristupnik/DNS iz njezina jedinog izvora), overlay ili goli host bridge (ne preporučuje se).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'host bridge:',
    ipAssignment: 'Dodjela IP-a',
    ipStatic: 'Statička',
    ipAuto: 'Automatska (IPAM)',
    ipAssignmentHint_static: 'Adresu dajete vi, sada.',
    ipAssignmentHint_auto: 'IPAM bira slobodnu adresu iz raspona mreže rezerviranih za TVirt.',
    bridgeDiscouraged: 'Goli host bridge — NE PREPORUČUJE SE: TVirt ne zna ništa o njegovu adresiranju, pa se pristupnik i DNS moraju dati ručno. Preporučeni put je logička mreža fabrica.',
    ip: 'IP',
    ipHint: 'Statički IPv4 unutar podmreže priključka.',
    ipCidrHint: 'U CIDR obliku na golom bridgeu (npr. 192.168.1.10/24) — nema odakle izvesti prefiks.',
    gateway: 'Pristupnik',
    gatewayManualHint: 'Ručno — goli bridge ništa ne izvodi.',
    dnsServers: 'DNS poslužitelji',
    dnsManualHint: 'Ručno, odvojeno zarezom — barem jedan.',
    rootKind: 'Root',
    rootEphemeral: 'privremeni',
    rootPersistent: 'trajni',
    rootEphemeralHint: 'Ponovno se stvara iz slike pri svakom ponovnom stvaranju; živi na klasterskom privremenom storageu.',
    rootEphemeralHintNamed: 'Ponovno se stvara iz slike pri svakom ponovnom stvaranju; živi na klasterskom privremenom storageu ({name}).',
    rootPersistentHint: 'Preživljava ponovna pokretanja; živi na storageu koji odaberete.',
    rootStorage: 'Root storage',
    editRootStorageHint: 'Root se ponovno renderira na novom poolu — postojeći se podaci NE premještaju sami.',
    volumes: 'Volumeni',
    volumeAdd: 'Dodaj volumen',
    volumeName: 'Naziv',
    volumeMountPath: 'Putanja montiranja',
    volumeKind: 'Tip',
    volumeStorage: 'Storage',
    devices: 'Uređaji',
    deviceClassHint: 'Traži se KLASA (oznaka gpu-device ili usb-device), nikad određeni uređaj: deklarirani čvor mora imati neki označen za Apps. Više Apps može koristiti isti uređaj — kontejner ga dijeli, ne oduzima ga hostu.',
    deviceSlot: 'Utor',
    deviceTag: 'Oznaka',
    deviceValue: 'Klasa',
    deviceUnresolved: 'trenutno se ništa ne razrješava',
    noDeviceTags: 'Još nema oznake vrste gpu-device ili usb-device: stvori je i dodijeli uređajima označenima za Apps.',
    env: 'Okruženje',
    envHint: 'Jedan KLJUČ=vrijednost po retku.',
    secretEnvTitle: 'Tajne varijable',
    secretEnvNotice: 'Tajna vrijednost više se nikad ne vraća iz API-ja: nitko je ne čita ponovno, pa ni onaj tko ju je upisao. U checkpointu putuje zapečaćena masterpassom, pa će vraćanje bez masterpassa tražiti da je ponovno upišete.',
    secretEnvPromote: 'Učinite tajnom jednu od gore upisanih varijabli:',
    secretEnvAdd: 'Dodaj tajnu varijablu',
    secretEnvName: 'Naziv',
    secretEnvValue: 'Vrijednost',
    secretEnvKept: 'sačuvana — ostavite prazno da je ne mijenjate',
    secretEnvWithdrawWarning: 'Da biste prestali tretirati kao tajnu varijablu koja to već jest, upišite joj novu vrijednost: samo skidanje oznake bilo bi način da se PROČITA ono što ne izlazi iz storea. Uklanjanje varijable, naprotiv, briše je.',
    secretEnvChip: 'tajno',
    startNow: 'Pokreni odmah (inače se aplikacija stvara zaustavljena)',
    deletePersistentIntro: 'Ova aplikacija ima trajne podatke — odaberite što s njima:',
    deleteKeepData: 'Zadrži podatke (direktoriji ostaju na svojim storageima, napušteni)',
    deletePurgeData: 'Izbriši i podatke',
    phase: 'Faza',
    phase_running: 'Pokrenuta',
    phase_stopped: 'Zaustavljena',
    phase_error: 'Pogreška',
    phase_unknown: 'Nepoznata',
    desiredState: 'Željeno',
    wantedRunning: 'pokrenuta',
    wantedStopped: 'zaustavljena',
    start: 'Pokreni',
    stop: 'Zaustavi',
    restart: 'Ponovno pokreni',
    refreshImage: 'Osvježi sliku (usvoji novi @current)',
    logs: 'Zapisnik',
    logsTitle: 'Zapisnik',
    logsEmpty: 'Nema uhvaćenog outputa.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'App nije pokrenuta — shell treba živ kontejner. Njezini logovi čitaju se u bilo kojem stanju.',
    shellConnect: 'Poveži',
    shellDisconnect: 'Prekini vezu',
    shellExited: 'Sesija je završila s izlaznim kodom {code}.',
    shellEndedWithoutStatus: 'Sesija je završila bez izlaznog statusa: {reason}',
    shellRevoked: 'Ticket sesije više nije valjan — istekao je ili je prijava koja ga je otvorila opozvana.',
    shellHint: 'Klikni na crno polje i tipkaj: tipke stižu do kontejnera. Ctrl+C i strelice rade; exit zatvara shell.',
    shellStatus: {
      connecting: 'Povezivanje…',
      connected: 'Povezana',
      ended: 'Završena'
    },
    deleteRunningError: '{name} je željeno pokrenuta — najprije je zaustavite.',
    tabs: {
      general: 'Općenito',
      image: 'Slika',
      network: 'Mreža',
      storage: 'Storage',
      devices: 'Uređaji',
      observed: 'Promatrano'
    },
    attachment: 'Priključak',
    runningDigest: 'Digest u radu',
    lastError: 'Zadnja pogreška',
    reportObservedAt: 'Zadnji izvještaj workera',
    desiredStateLock: 'Njime upravljaju radnje Pokreni/Zaustavi — nikad izravno uređivanje.',
    ipEditDisabledHint: 'Uredivo samo uz statičku dodjelu.',
    derivedFromNetworkHint: 'Izvedeno iz jedinog izvora mreže — ručno samo na golom bridgeu sa statičkim IP-om.',
    ephemeralUnset: 'nije konfigurirano',
    ephemeralMissing: 'Privremeni storage aplikacija nije konfiguriran — stvaranje aplikacije s bilo kojim privremenim dijelom (root ili volumeni) odbija se dok ga ne postavite.',
    ephemeralCurrent: 'Privremeni storage aplikacija: {name}',
    ephemeralMissingCreate: 'Ova aplikacija ima privremene dijelove, ali klasterski privremeni storage aplikacija nije postavljen — stvaranje će biti odbijeno. Najprije ga postavite s bannera na stranici Aplikacije.',
    setEphemeral: 'Postavi privremeni storage',
    changeEphemeral: 'Promijeni privremeni storage',
    setEphemeralTitle: 'Postavite privremeni storage aplikacija',
    changeEphemeralTitle: 'Promijenite privremeni storage aplikacija',
    ephemeralStorageHint: 'ZADANO na razini klastera: dir-like pool na kojem žive privremeni rootovi i privremeni volumeni svake aplikacije, osim ako aplikacija ne deklarira vlastiti override. Promjena se ne primjenjuje u hodu i ništa ponovno ne pokreće: vrijedi od sljedećeg pokretanja svake aplikacije — privremeni se podaci ne premještaju.',
    ephemeralPool: 'Storage pool',
    ephemeralOverride: 'Privremeni storage (override po aplikaciji)',
    ephemeralOverrideInherit: 'Naslijedi zadanu vrijednost klastera',
    ephemeralOverrideInheritNamed: 'Naslijedi zadanu vrijednost klastera ({name})',
    ephemeralOverrideHint: 'Pool po aplikaciji za privremeni root i volumene — ostavite prazno da naslijedite zadanu vrijednost klastera. Promjena se ne primjenjuje u hodu i ništa ponovno ne pokreće: vrijedi od sljedećeg pokretanja (privremeni podaci ponovno se rađaju prazni na novom poolu) i zahtijeva dozvolu app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Sve grane',
    imageBranchHint: 'Sužava slike na one koje imenuje ova grana; bez grane vide se sve slike repozitorija.',
    imageDigestHint: 'Sadržaj: bira se iz tablice digesta, koja nosi njegovo podrijetlo i arhitekturu. Ista grana nudi po jedan za arhitekturu i nisu zamjenjivi.',
    imageLockfile: 'Razriješena referenca',
    imageNoImages: 'Nema slika u predmemoriji za ovaj repozitorij — preuzmi jednu iz OCI slika.',
    imageHeadNotCached: 'nije u cacheu — preuzima se pri pokretanju',
    imageNoRegistries: 'Nije registriran nijedan repozitorij: registriraj jedan da bi mogao odabrati sliku.',
    imageChosenHint: 'Slika se bira kaskadom u dijalogu izmjene: referenca se nikad ne upisuje ručno.',
    registerRepositoryHint: 'Registriranje ništa ne preuzima: čini repozitorij praćenim, da bi se slika mogla odabrati bez napuštanja ovog dijaloga.',
    registerRepositoryBranchHint: 'Neobavezno: prva grana koju treba pratiti (npr. latest).',
    registerRepositoryElsewhere: 'Traženi repozitorij nije registriran: registriranje se radi u odjeljku OCI slike, od strane nekoga tko ima dopuštenje.'
  },
  cts: {
    createAction: 'Stvori CT',
    createTitle: 'Stvorite kontejner iz predloška',
    createError: 'Kontejner nije stvoren',
    template: 'CT predložak',
    noTemplates: 'Još nema CT predložaka — uvezite jedan pod CT predlošci',
    resources: 'Resursi',
    node: 'Čvor',
    phase: {
      defined: 'Nikad uključen',
      materializing: 'Materijalizira se',
      ready: 'Spreman',
      starting: 'Pokreće se',
      running: 'Pokrenut',
      stopping: 'Zaustavlja se',
      stopped: 'Zaustavljen',
      deleting: 'Briše se',
      error: 'Pogreška'
    },
    actions: {
      start: 'Pokreni',
      stop: 'Zaustavi',
      restart: 'Ponovno pokreni',
      markTemplate: 'Promakni u CT predložak',
      error: 'Radnja je odbijena'
    },
    markTemplate: {
      confirmTitle: "Promaknuti '{name}' u CT predložak?",
      confirmBody: 'Kontejner napušta ovaj popis i prelazi među CT predloške, odmah spreman stvarati nove CT-ove. Njegovi metapodaci ostaju uredivi, a u svakom ga trenutku možete vratiti u CT.',
      confirm: 'Promakni',
      moved: "'{name}' je sada CT predložak — naći ćete ga pod CT predlošci."
    },
    stopCause: {
      api: 'Zaustavljen putem TVirta',
      'ct-exit': 'Kontejner je izašao sam od sebe',
      'host-reboot': 'Umro s ponovnim pokretanjem čvora',
      'start-failed': 'Pokretanje nije uspjelo — pogreška zadatka kaže što nedostaje i kako to popraviti'
    },

    console: 'Konzola',
    consoleUnavailable: 'Kontejner nije pokrenut — konzoli treba živ kontejner. Njegov se zapisnik pak čita u bilo kojem stanju.',
    consoleNoTemplate: 'Predložak nikad ne radi pa nema konzolu: stvorite iz njega CT i otvorite njegovu.',
    consoleConnect: 'Poveži',
    consoleDisconnect: 'Odspoji',
    consoleReconnect: 'Ponovno poveži',
    consoleTakenBy: 'Ovu je konzolu preuzeo drugi operater ({user}). Jedna konzola po kontejneru: ponovno povezivanje vraća je vama.',
    consoleHint: 'Kliknite crno polje i pišite: tipke stižu do kontejnera. Ctrl+C i strelice rade.',
    consoleEndpointDown: 'Pristupna točka konzole ne može se otvoriti na čvoru koji poslužuje container: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Container nije pokrenut — shell treba živ container. Njegovi se logovi mogu čitati u bilo kojem stanju.',
    shellNoTemplate: 'Template se nikad ne izvodi, pa nema shell: napravi CT iz njega i otvori njegov.',
    shellConnect: 'Poveži',
    shellDisconnect: 'Prekini vezu',
    shellExited: 'Sesija je završila s izlaznim kodom {code}.',
    shellEndedWithoutStatus: 'Sesija je završila bez izlaznog statusa: {reason}',
    shellRevoked: 'Ticket sesije više nije valjan — istekao je ili je prijava koja ga je otvorila opozvana.',
    shellHint: 'Klikni na crno polje i tipkaj: tipke stižu do kontejnera. Ctrl+C i strelice rade; exit zatvara shell.',
    shellStatus: {
      connecting: 'Povezivanje…',
      connected: 'Povezana',
      ended: 'Završena'
    },
    rootPassword: 'Lozinka roota',
    rootPasswordHint: 'Zapisuje se jednom u kopirani rootfs (kao hash, više se ne prikazuje). Slike distribucija nemaju lozinku roota: bez nje je shell jedini ulaz.',
    sshKeys: 'Javni SSH ključevi roota',
    sshKeysHint: 'Jedan javni OpenSSH ključ po retku, u root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Povezivanje…',
      connected: 'Povezana',
      reconnecting: 'Ponovno povezivanje…'
    },
    logs: 'Zapisnik',
    logsTitle: 'Zapisnik',
    logsEmpty: 'Nema uhvaćenog outputa.',
    logsSource: 'Koji zapisnik',
    logsSourceConsole: 'Konzola inita kontejnera — zašto se usluga unutra nije pokrenula',
    logsSourceSupervisor: 'Nadzornik liblxc — zašto kontejner nikad nije ni došao do pokretanja',
    logsNeverStarted: 'Nikad nije pokrenut pa još nema ništa zabilježeno — pokrenite ga i zapisnik će biti tu čak i ako pokretanje ne uspije.',
    logsNoTemplate: 'Predložak nikad ne radi pa nikad ništa nije ni zabilježio.',
    logsError: 'Zapisnik nije uhvaćen',

    tabs: {
      general: 'Općenito',
      hardware: 'Hardver',
      network: 'Mreža',
      provenance: 'Podrijetlo'
    },
    templateFlag: 'CT predložak',
    templateLock: 'Mijenja se samo radnjama Promakni / Vrati u CT — nikad izravnim uređivanjem.',
    sourceLock: 'Podrijetlo, zabilježeno pri nastanku — nikad se ne prepisuje; mrtav izvor ostavlja golu referencu.',
    storageLock: 'Fiksirano pri stvaranju — premještanje rootfsa dolazi u budućem roundu.',
    startedAt: 'Pokrenut',
    lastStop: 'Zadnje zaustavljanje',
    editNicsTitle: 'Uredite mreže',
    nicDisconnected: 'odvojen'
  },
  ctTemplates: {
    title: 'CT predlošci',
    importAction: 'Uvezi iz kataloga',
    importTitle: 'Uvezite CT predložak iz kataloga',
    importSubmit: 'Uvezi',
    importError: 'Uvoz je odbijen',
    importHint: 'Materijalizacija kopira rootfs na odabrani storage — datoteka kataloga ostaje netaknuta. Za dodavanje novih datoteka najprije ih prenesite u katalog.',
    sourceFile: 'Datoteka CT predloška',
    sourceFileHint: 'ct-rootfs datoteke odabranog kataloga, samo one spremne',
    noFiles: 'U ovom katalogu nema spremne ct-rootfs datoteke — najprije prenesite jednu sa stranice kataloga',
    source: 'Izvorna datoteka',
    rootfsStorage: 'Storage rootfsa',
    rootfsStorageHint: "Gdje živi raspakirano rootfs stablo — storage s datotečnim sustavom i dovoljno slobodnog prostora za raspakiranu veličinu plus otprilike 1 GiB rezerve (inače uvoz neće uspjeti).",
    resources: 'Resursi',
    cores: 'vCPU',
    memoryMiB: 'Memorija (MiB)',
    cpuLimit: 'Ograničenje CPU-a',
    cpuLimitHint: 'Ekvivalenti host coreova (npr. 1.5); prazno = bez ograničenja',
    cpuUncapped: 'bez ograničenja',
    cpuWeight: 'Težina CPU-a',
    hostname: 'Hostname',
    hostnameHint: 'Prazno = vlastito ime CT-a',
    nameservers: 'DNS nameserveri',
    dnsHint: 'Odvojeni zarezom; prazno = naslijedi one od hosta',
    searchDomains: 'DNS domene pretraživanja',
    dnsInherited: 'Naslijeđeno od hosta',
    networks: 'Mreže',
    nicSlot: 'NIC slot',
    phase: {
      materializing: 'Materijalizira se',
      ready: 'Spreman',
      deleting: 'Briše se',
      error: 'Pogreška'
    },
    exportAction: 'Izvezi u katalog',
    exportTitle: 'Izvezite u katalog',
    exportSubmit: 'Izvezi',
    exportError: 'Izvoz je odbijen',
    exportHint: 'Pakira materijalizirani rootfs u NOVU ct-rootfs datoteku u odabranom katalogu — predložak ostaje netaknut.',
    exportName: 'Naziv datoteke',
    exportNameHint: 'Prazno = <template>-export-<n>',
    markCt: {
      action: 'Vrati u CT',
      confirmTitle: "Vratiti '{name}' u CT?",
      confirmBody: 'Predložak napušta ovaj popis i vraća se na popis CT-ova, ponovno ga je moguće pokrenuti. Dok ga ponovno ne promaknete, iz njega se ne mogu stvarati novi CT-ovi.',
      confirm: 'Vrati u CT',
      moved: "'{name}' je ponovno CT — naći ćete ga na popisu CT-ova."
    }
  },
  oci: {
    registriesTitle: 'OCI registry',
    imagesTitle: 'OCI slike',
    provider: 'Provider',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Generički',
    providerImmutableHint: 'Provider je nepromjenjiv nakon stvaranja — drugi provider znači novi registry.',
    url: 'URL',
    urlHintPreset: 'Unaprijed zadano providerom — prepišite samo za mirrore.',
    urlHintRequired: 'Obavezno za generički registry: bazni https:// URL.',
    urlHintEcr: 'Obavezno: ECR endpointi su po računu/po regiji — preset ne postoji.',
    credential: 'Vjerodajnica',
    credentialNone: 'Anonimni pristup',
    credentialHint: 'Keystore stavka s korisničkim imenom i lozinkom; workeri je razrješavaju u trenutku uporabe — nikad auth datoteke po čvoru.',
    nameHint: 'Naziv nalik hostu (docker.io, registry.intra); jedinstven po scopeu, nepromjenjiv',
    addRegistry: 'Dodaj registry',
    addRegistryTitle: 'Dodajte OCI registry',
    verify: 'Provjeri',
    verifyState: 'Provjera',
    verified: 'Provjereno',
    verifyFailed: 'Neuspješna',
    neverVerified: 'Nikad provjereno',
    registryInUseError: "'{name}' još ima registrirane repozitorije — najprije ih izbrišite.",
    repositories: 'Repozitoriji',
    repositoriesHint: 'Registriranje promatra brancheve (OCI tagove) — ništa se ne preuzima. Refresh razrješava svaki promatrani branch i čuva reflog.',
    noRepositories: 'Nijedan repozitorij nije registriran na ovom registryju.',
    registerRepository: 'Registriraj repozitorij',
    repoPath: 'Putanja',
    repoPathHint: "Putanja repozitorija na registryju, npr. 'example' ili 'library/nginx'",
    branches: 'Branchevi',
    branchesHint: 'Promatrani branchevi (OCI tagovi), odvojeni zarezom — npr. 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'Razriješeno SADA: pull preuzima digest na koji branch pokazuje danas.',
    refresh: 'Osvježi',
    deleteRepository: 'Izbriši repozitorij',
    reflogCount: 'prethodnih: {n}',
    noResolutions: 'Nikad osvježeno — još nema promatranih razrješenja.',
    refreshFailed: 'Zadnje osvježavanje nije uspjelo ({when})',
    loadError: 'Repozitorije nije moguće učitati.',
    reference: 'Referenca',
    digest: 'Digest',
    digestHint: 'sha256:… — točno određena slika, bez brancha (detached)',
    size: 'Veličina',
    nodes: 'Čvorovi',
    detached: 'detached',
    detachedHint: 'Preuzeta po digestu, bez brancha — drift provjera se ne primjenjuje.',
    pulledAt: 'Preuzeta',
    pull: 'Pull',
    pullTitle: 'Pull slike',
    pullHint: 'Pre-warming, nikad preduvjet: pull po branchu razrješava SADA i preuzima TAJ digest; pull po digestu je detached.',
    pullError: 'Pull je odbijen',
    pullMode: 'Pull po',
    pullModeBranch: 'Branch (razriješi sada)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'Pošteno zadano: kao apt install — ponovljeno kasnije može dati drugu sliku.',
    pullModeDigestHint: 'Točan digest — ponovljivost i rollback; odriče se drift provjere.',
    importFromRegistry: 'Uvezi iz registryja',
    importFromCatalog: 'Uvezi iz kataloga',
    importCatalogTitle: 'Uvezite OCI sliku iz kataloga',
    importCatalogHint: 'Air-gapped put: spremna oci-image arhiva (tar/tar.gz — docker-archive ili oci-archive) materijalizira se u store slika s referencom catalog/<katalog>/<datoteka>@<digest>; aplikacije je konzumiraju kao bilo koju drugu sliku. Arhive se prenose u katalozima — ovaj odjeljak samo uvozi.',
    importCatalogFile: 'Arhiva',
    importCatalogFileHint: 'Spremne oci-image datoteke odabranog kataloga.',
    importCatalogNoFiles: 'U ovom katalogu nema spremne oci-image arhive — prenesite jednu iz detalja kataloga.',
    importCatalogError: 'Uvoz je odbijen',
    registry: 'Registry',
    repository: 'Repozitorij',
    cacheMissing: 'Klasterska OCI predmemorija nije konfigurirana — pullovi se odbijaju dok ne postavite storage pool.',
    setCache: 'Postavi predmemoriju',
    setCacheTitle: 'Konfigurirajte OCI predmemoriju',
    setCacheHint: 'ZADANI pool na razini klastera koji sadrži blobove preuzetih slika — scope može napraviti override vlastitim poolom (stranica Scope). Promjena se ne primjenjuje u hodu i ništa ponovno ne pokreće, a blobove nikad ne premješta: lijeno se ponovno pojavljuju pri sljedećem pokretanju/uporabi.',
    cachePool: 'Storage pool',
    changeCache: 'Promijeni predmemoriju',
    changeCacheTitle: 'Promijenite pool OCI predmemorije',
    cacheCurrent: 'OCI predmemorija klastera (zadano): {name}',
    sectionOverview: 'Pregled',
    sectionRepositories: 'Repozitoriji',
    sectionExplore: 'Istraži',
    exploreHint: 'Udaljena pretraga uživo na registryju — Docker Hub potpuna (opis, preuzimanja, zvjezdice), ostali provideri best-effort. Odaberite rezultat da pročitate potpuni opis i prelistate njegove udaljene tagove; s taga možete dodati referencu u TVirt repozitorij.',
    exploreSearch: 'Pretraži',
    exploreUnsupported: 'Ovaj provider ne podržava pretraživanje.',
    exploreNoResult: 'Nijedan repozitorij ne odgovara.',
    exploreNoTags: 'Nijedan tag na ovom repozitoriju ne odgovara.',
    exploreOfficial: 'Službeno',
    explorePulls: 'Preuzimanja',
    exploreStars: 'Zvjezdice',
    exploreUpdated: 'Ažurirano {when}',
    exploreLoadMore: 'Učitaj još',
    exploreSelectHint: 'Odaberite rezultat: potpuni opis i udaljeni tagovi učitavaju se ovdje.',
    exploreNoDescription: 'Nema dostupnog opisa od ovog providera.',
    exploreTagsTitle: 'Udaljeni tagovi',
    exploreTagFilter: 'Pretraži tagove',
    exploreAddToRepo: 'Dodaj u repozitorij',
    exploreAdded: '{path}:{tag} sada se prati — pogledajte odjeljak Repozitoriji.',
    addBranch: 'Dodaj branch',
    purgeRequiredTitle: "Izbrisati '{name}' i njegove slike?",
    purgeRequiredBody: 'Nijedna aplikacija ne konzumira ovaj repozitorij, ali preuzete slike još postoje: brisanjem se uklanjaju i njihovi zapisi, a blobovi u predmemoriji odlaze garbage collectoru.',
    purgeConfirm: 'Izbriši i slike',
    providerSelectHint: 'Odaberite tip registryja: kartica opisuje preset i namjenu.',
    providerDesc: {
      dockerhub: 'Javni Docker registry: unaprijed zadan URL, potpuna pretraga s opisima i brojčanicima.',
      ghcr: 'GitHub Container Registry: unaprijed zadan URL; računi koriste personal access token.',
      ecr: 'Amazon Elastic Container Registry: endpointi po računu/po regiji — URL se mora navesti.',
      quay: 'Registry Red Hat Quay: unaprijed zadan URL.',
      generic: 'Self-hosted registry (Harbor, registry:2, …): https:// URL je obavezan.'
    },
    layerCount: 'Layeri',
    verifiedAt: 'Zadnja provjera',
    verifyOk: 'Ishod',
    verifyMessage: 'Poruka provjere',

    // Model #348/R39: slika JEST digest — sadržaj — a registry, repozitorij i grana su IMENA koja do njega vode.
    head: 'Head',
    heads: 'Glave po arhitekturi',
    listDigest: 'Digest popisa',
    neverResolved: 'Nikad razriješen',
    totalSize: 'Ukupna veličina',
    reflogTitle: 'Povijest razrješenja',
    usedBy: 'Koriste',
    usageLockfile: 'lockfile',
    usageRunning: 'u radu',
    evictable: 'izbaciv',
    evict: 'Izbaci iz predmemorije',
    evictHeadTitle: 'Izbaciti {digest}?',
    evictHeadBody: 'To je trenutačno razrješenje barem jednog kolektora: izbaciti ga je legitimno — riječ je samo o predmemoriji, udaljeni branch ga i dalje poslužuje — ali to se nikad ne smije dogoditi zabunom. Blob je JEDAN: izbacivanje prazni sve kolektore koji ga dijele.',
    evictConfirm: 'Svejedno ga izbaci',

    arch: 'Arhitektura',
    names: 'Imena',
    noNames: 'bez imena',
    views: 'Prikazi',
    lastView: 'posljednji prikaz',
    evictLastViewTitle: 'Ukloniti posljednju referencu na {digest}?',
    evictLastViewBody: 'Ovo je posljednji prikaz ovog sadržaja: uklanjanjem slika prestaje postojati na TVirtu, a bajtovi ({size}) se oslobađaju. To je docker image rm ovog modela — nije nuspojava, već sama operacija.',
    branchesTabHint: 'Praćene grane ovog repozitorija: za svaku današnje glave — po jedna za arhitekturu — kronologija osvježavanja i koliko njome imenovanih slika je u predmemoriji. Osvježavanje je «git fetch» repozitorija: razrješava sve njegove grane odjednom.',
    noBranches: 'U ovom repozitoriju ne prati se nijedna grana.',
    stopObserving: 'Prestani pratiti granu',
    pullBranch: 'Preuzmi u cache glavu brancha (refresh razrješava, ovo preuzima)',
    pullDigest: 'Preuzmi ovaj digest u cache',
    imageCount: 'Slike',
    deleteBranchPurgeTitle: 'Ostaviti slike iz {name} bez imena?',
    deleteBranchPurgeBody: 'Nijedna aplikacija ne imenuje ovu granu, ali neke slike dosežu se samo preko nje: njezinim brisanjem ostaju u predmemoriji bez imena, navedene među slikama repozitorija i uklonjive ručno.',
    deleteBranchPurgeConfirm: 'Obriši i ostavi slike bez imena',
    imagesTabHint: 'Slike ovog repozitorija — sadržaji, to jest digesti — vidljive i bez odabira grane. Slika je jedinstvena po klasteru: imena koja do nje vode može biti više.',
    noImages: 'Nijedna slika ovog repozitorija nije materijalizirana u predmemoriji.',
    deleteRepositoryTitle: 'Obrisati {name}?',
    deleteRepositoryBody: 'Repozitorij i njegove grane nestaju sa svojom kronologijom. Slike ostaju u predmemoriji: gube samo ovo ime. Repozitorij koji imenuje aplikacija ne može se obrisati.',
    provenanceCatalog: 'katalog',
    refreshedAt: 'Osvježeno',
    neverRefreshed: 'Nikad osvježeno',
    sectionBranches: 'Grane',
    sectionImages: 'Slike',
    repositoriesGovernedElsewhere: 'Ovdje se repozitoriji samo gledaju: registriranje, osvježavanje, praćenje grana i uklanjanje slika radi se u odjeljku OCI slike.',
    gotoImages: 'Idi na OCI slike'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Podovi',
    containers: 'Kontejneri',
    instances: 'Instance',
    instancesTooltip: '{running} pokrenuto, {error} u grešci',
    placement: 'Smještaj',
    spread: 'raspodjela',
    ha: 'HA',
    templateRevision: 'revizija',
    deleting: 'Briše se',
    empty: 'Nema podova — stvorite aplikaciju (jedan kontejner) ili pod iz CLI-ja (create-pod).',
    openInstances: 'Otvori instance',
    rollingRestart: 'Postupno ponovno pokretanje',
    scale: 'Skaliraj',
    scaleTitle: 'Skaliraj {name}',
    scaleHint: 'Broj instanci (0–64): prema gore popunjava se najniži slobodni redni broj, prema dolje povlači se najviši, a njegovi trajni podaci ostaju.',
    scaleError: 'Skaliranje nije uspjelo',
    replicas: 'Replike',
    deleteRunningError: '{name} je pokrenut — najprije ga zaustavite.',
    deleteInstancesIntro: 'Svih {count} instanci bit će uklonjeno.',
    stateRunning: 'Pokrenut',
    stateStopped: 'Zaustavljen',
    editor: {
      createTitle: 'Stvori Pod',
      create: 'Stvori Pod',
      editTitle: 'Uredi Pod',
      nameHint: 'DNS-1123, najviše 58 znakova — instance se zovu <ime>-<indeks>; nepromjenjivo nakon stvaranja.',
      restartPolicy: 'Politika ponovnog pokretanja',
      restartPolicyHint_always: 'Čvor ponovno pokreće svaki izašli kontejner, s eksponencijalnim backoffom (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Ponovno se pokreće samo kontejner koji je izašao s kodom različitim od nule; izlaz 0 miruje.',
      restartPolicyHint_never: 'Izašli kontejner ostaje kakav jest — instanca završava kao succeeded ili failed.',
      grace: 'Odgoda (s)',
      graceHint: 'Granica SIGTERM → SIGKILL zaustavljanja.',
      hostname: 'Ime računala',
      hostnameHint: 'Prazno = ime instance.',
      hostnameDefault: 'ime instance',
      sharePid: 'Dijeli PID imenski prostor između kontejnera',
      containersIntro: 'Init kontejneri se izvršavaju do kraja, redom, prije nego kontejneri krenu; kontejneri dijele mrežu instance (jedan IP, localhost među njima).',
      initContainers: 'Init kontejneri',
      initAdd: 'Dodaj init kontejner',
      initHint: 'Svaki mora izaći s 0; neuspjeh stavlja instancu u grešku, a čvor ga ponavlja s backoffom.',
      containerAdd: 'Dodaj kontejner',
      atLeastOne: 'Pod treba barem jedan kontejner.',
      duplicateNames: 'Imena kontejnera moraju biti jedinstvena unutar Poda (uključujući init kontejnere).',
      containerName: 'Ime kontejnera',
      containerInvalid: 'Ovaj kontejner je nepotpun: ime (DNS-1123), slika, montiranja na deklarirane volumene, brojčani limiti i sonda.',
      command: 'Naredba',
      commandHint: 'Zamjenjuje entrypoint slike — jedan argument po retku, nikad shell string.',
      args: 'Argumenti',
      argsHint: 'Jedan po retku (CMD slike ako je prazno).',
      mounts: 'Montiranja',
      mountAdd: 'Dodaj montiranje',
      mountNoVolumes: 'Najprije deklarirajte volumen u kartici Pohrana.',
      readOnly: 'samo za čitanje',
      resources: 'Limiti',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (npr. 1.5)',
      memory: 'Memorija (MiB)',
      memoryHint: 'podman --memory',
      health: 'Sonda živosti',
      healthCmd: 'Naredba sonde',
      healthCmdHint: 'Čvor je izvršava u kontejneru pri svakom nadzornom otkucaju — jedan argument po retku; izlaz 0 = zdravo.',
      healthTimeout: 'Vremensko ograničenje (s)',
      healthRetries: 'Pokušaji',
      healthRetriesHint: 'Uzastopni neuspjesi prije nego čvor ponovno pokrene kontejner.',
      ips: 'Statičke adrese',
      ipsHint: 'Jedna po instanci, po rednom broju — skaliranje izvan popisa se odbija.',
      instance: 'instanca',
      volumesHint: 'Volumeni su Podovi; putanja montiranja pripada svakom kontejneru (kartica Kontejneri).',
      spread: 'Raspodjela',
      spreadHint_preferred: 'Instance na različitim čvorovima kad je moguće.',
      spreadHint_required: 'Instance na različitim čvorovima, inače skaliranje odbija.',
      spreadHint_none: 'Samo odlučivač.',
      ha: 'Visoka dostupnost (opt-in)',
      haHint: 'Svaki trajni dio na dijeljenom storageu; ako čvor umre, HA decider ponovno stvara instance na drugom članu (automatski failover, kao kod HA VM-ova).',
      yes: 'da',
      no: 'ne'
    },
    detail: {
      container: 'Kontejner',
      actions: 'Radnje',
      ready: 'Spreman',
      notReady: 'Nije spreman',
      restarts: 'Ponovna pokretanja',
      lastRestartAt: 'Zadnje ponovno pokretanje:',
      backoffUntil: 'Ponovni pokušaj u',
      stateAbsent: 'odsutan',
      stateRunning: 'radi',
      stateTerminated: 'završen',
      stateWaiting: 'čeka',
      init: 'init',
      noInstances: 'Nema instanci (replike 0).',
      ha: 'HA',
      haHint: 'Automatski failover: ako čvor umre, HA decider ponovno stvara instancu na drugom članu (svaki trajni dio na dijeljenom storageu).',
      authority: 'Authority (čvor)',
      homeless: 'bez authorityja',
      homelessHint: 'Vraćanje iz checkpointa izostavlja authority (#380): nijedan čvor je ne poslužuje dok ne skalirate Pod (makar na isti broj replika).',
      restartContainer: 'Ponovno pokreni samo ovaj kontejner (pod ostaje aktivan)',
      divergingHint: 'Željeno stanje ove instance razlikuje se od zadanog stanja Poda (PD-P19).',
      revisionLag: 'revizija {applied} primijenjena od {current}',
      updatedInstances: '{updated}/{desired} instanci na ovoj reviziji'
    }
  }
}
